export const ViewState = {
	InitialView: "initial",
	EditView: "edit",
};

// @ts-ignore
export type ViewStateType = ViewState.InitialView | ViewState.EditView;
